import React from 'react'

import Text from 'src/Components/Text'

const defaultProps = {
  element: 'h2',
  size: 'xl',
  weight: 'light',
  paragraph: true
}

const Heading = props => <Text {...props} />

Heading.defaultProps = defaultProps

export default Heading
